import SmartAnalyticsCompanyComponent from '../Components/SmartAnalytics/SmartAnalyticsCompanyComponent';

function SmartAnalyticsCompanyPage() {
  return <SmartAnalyticsCompanyComponent />;
}

export default SmartAnalyticsCompanyPage;
